/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KycLink } from './KycLink';
import {
    KycLinkFromJSON,
    KycLinkFromJSONTyped,
    KycLinkToJSON,
} from './KycLink';

/**
 * 
 * @export
 * @interface KycLinkResponse
 */
export interface KycLinkResponse {
    /**
     * 
     * @type {boolean}
     * @memberof KycLinkResponse
     */
    status: boolean;
    /**
     * 
     * @type {number}
     * @memberof KycLinkResponse
     */
    statusCode: number;
    /**
     * 
     * @type {string}
     * @memberof KycLinkResponse
     */
    errorMessage?: string;
    /**
     * 
     * @type {KycLink}
     * @memberof KycLinkResponse
     */
    data?: KycLink;
}

/**
 * Check if a given object implements the KycLinkResponse interface.
 */
export function instanceOfKycLinkResponse(value: object): boolean {
    if (!('status' in value)) return false;
    if (!('statusCode' in value)) return false;
    return true;
}

export function KycLinkResponseFromJSON(json: any): KycLinkResponse {
    return KycLinkResponseFromJSONTyped(json, false);
}

export function KycLinkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): KycLinkResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'statusCode': json['status_code'],
        'errorMessage': json['error_message'] == null ? undefined : json['error_message'],
        'data': json['data'] == null ? undefined : KycLinkFromJSON(json['data']),
    };
}

export function KycLinkResponseToJSON(value?: KycLinkResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': value['status'],
        'status_code': value['statusCode'],
        'error_message': value['errorMessage'],
        'data': KycLinkToJSON(value['data']),
    };
}

